/*
 * update existing bars
 */

import drawBars from './draw_bars.js'
// import drawExceedLine from './draw_exceed_line.js'

export default ({
  svg,
  x,
  y,
  height,
  width
}, data) => {
// FIXME use general d3 update pattern
// https://bl.ocks.org/mbostock/3808218
  svg.selectAll('.history-chart__bar').remove()
  // svg.select('.history-chart__exceed-line').remove()
  const selection = svg.selectAll('.history-chart__bar').data(data).enter()
  drawBars({selection, x, y, height})
  // drawExceedLine({svg, y, width})
}



// WEBPACK FOOTER //
// ./src/components/station-infobox/update_bars.js